import { createContext, useContext, useState, useCallback, type ReactNode } from 'react';

interface LayoutContextValue {
  sidebarOpen: boolean;
  setSidebarOpen: (open: boolean) => void;
  closeSidebar: () => void;
}

const LayoutContext = createContext<LayoutContextValue | null>(null);

export function LayoutProvider({ children }: { children: ReactNode }) {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const closeSidebar = useCallback(() => setSidebarOpen(false), []);
  return (
    <LayoutContext.Provider value={{ sidebarOpen, setSidebarOpen, closeSidebar }}>
      {children}
    </LayoutContext.Provider>
  );
}

export function useLayout() {
  const ctx = useContext(LayoutContext);
  return ctx ?? { sidebarOpen: false, setSidebarOpen: () => {}, closeSidebar: () => {} };
}
